import React, { useLayoutEffect, useRef, useState, useEffect } from "react";
  import {
    DataTable,
    Column,
    Dropdown,
    InputText,
    MultiSelect,
    iconSet,
    IcomoonReact,
  } from "../PrimeReact.js";
  import "../../assets/styles/accountant/chartofaccount.scss";
  import ItemsService from "../../services/items";
  import GV from "../../services/globalVar";
  import { SearchOutlined } from "@ant-design/icons";
  import { Tooltip, Input, Space } from "antd";
  import JournalService from "../../services/journal.js";
  import { DatePicker } from "antd";
  import { Dropdown as Primedropdown } from "primereact/dropdown";
  import moment from "moment";
  import { format } from "date-fns";
  import GlobalVariable from "../../../../client/src/services/globalVar";
import * as XLSX from "xlsx";

const BankTransaction = (props) => {
  const parentData = props;
    const modalref = useRef(null);
    const its = new ItemsService();
    const jor = new JournalService();
      //   useEffect(() => {
      //   return () => {
      //     Object.values(jor.controllers).forEach((c) => c.abort());
      //     jor.controllers = {}; 
      //   };
      // }, []);
  const currency = GV.userDet.tenantConfig.currency;

    const [first1, setFirst1] = useState(0);
    const [tdataLoad, setTdataLoad] = useState(false);
    const [data, setData] = useState([]);
    const [totalRecordsIn, setTotalRecordsIn] = useState(0);
    const [page, setPage] = useState(1);
    const [sizePerPage, setSizePerPage] = useState(10);
    const [sortName, setSortName] = useState("");
    const [sortOrder, setSortOrder] = useState("");
    const [searchVal, setSearchVal] = useState("");
    const [isMounted, setIsMounted] = useState(true);
    const [requestData, setRequestData] = useState([]);
    const [accountSelected, setAccountSelected] = useState("All");
    const [itemId, setItemId] = useState("");
    const { RangePicker } = DatePicker;
    const [passDteRange, setPassDteRange] = useState([]);
    const [fromDate, setFromDate] = useState();
    const [toDate, setToDate] = useState();
    const [selectPeriod, setSelectPeriod] = useState("This Month");

    const itemStatus = [
      { label: "All Accounts", value: "All", status: true, type: "All" },
      { label: "Active Accounts", value: "Active", status: true, type: "All" },
      { label: "Inactive Accounts", value: "Inactive", status: true, type: "All" },
      { label: "Custom", value: "Custom", status: true, type: "All" },
    ];

    const items = [
      { label: "This Month", value: "This Month" },
      { label: "Last 3 Month", value: "Last 3 Months" },
      { label: "Last 6 Month", value: "Last 6 Months" },
      { label: "Last 12 Month", value: "Last 12 Months" },
      { label: "This Year", value: "This Year" },
      { label: "Custom", value: "Custom" },
    ];
  
    const [statusSelected, setStatusSelected] = useState(itemStatus[0].value);
    const [filterSelected, setFilterSelected] = useState(itemStatus[0].value);

    const balances = [
        { label: "Bank Balance", amount: -6855 },
        { label: "Card Balance", amount: 4497 },
        { label: "Cash In Hand", amount: 8605 },
        { label: "Payment Clearing", amount: -9588 }
      ];
      

      const onCustomPage1 = (event) => {
        setFirst1(event.first);
        const val = event.page + 1;
        const size = event.rows;
        setSizePerPage(size);
        setPage(val);
        fetchBankDetails(
          val,
          size,
          searchVal,
          "",
          "",
          ""
                  );
      };
      //sort start
      const [lazyParams, setLazyParams] = useState({
        first: first1,
        rows: sizePerPage,
        page: page,
        sortField: sortName,
        sortOrder: sortOrder,
      });
      const onSort = (event) => {
        setLazyParams(event);
      };

      function fetchBankDetails(
        page,
        sizePerPage,
        searchVal,
        sortName,
        sortOrder,
        fromDate,
        toDate,
        peried
      ) {
        // setTdataLoad(true);
        setTdataLoad(true);
        let data = {
          InputParams: {
            TenantID: GV.userDet.tenantDetail.tenantID,
            "Period": peried,
            "FromDate": fromDate ? fromDate : null,
            "ToDate": toDate ? toDate : null
          
          },
          ServerSearchables: {
            draw: page,
            searchData: searchVal,
            orderByColumn: sortName,
            orderBy: sortOrder,
            currentPage: page,
            pageSize: sizePerPage,
            pageNumber: page,
          },
        };
        jor
          .GetLedgerBankTransactionListSearch(data)
          .then((res) => {
           setTdataLoad(false);
            if (res.data) {
             setData(res.data.data.ledgerBankList);
             setTotalRecordsIn(res.data.data.serverSearchables.recordsTotal);
            }
          }).catch((err) =>
            setTdataLoad(false)
          )
      }
      const handleDateRange = (dates, dateString) => {
        if (dateString && dateString.length === 2) {
          const startDate = moment(dateString[0]).format("YYYY-MM-DD");
          const endDate = moment(dateString[1]).format("YYYY-MM-DD");
          const dateRangeString = `${startDate} - ${endDate}`;
          setFromDate(startDate);
          setToDate(endDate);
          fetchBankDetails(
            page,
            sizePerPage,
            searchVal,
            "",
            "",
            startDate,
            endDate,
            selectPeriod    
          );
          setPassDteRange([dateRangeString]);
        }
      };

      const keySearch = (e) => {
        setSearchVal(e.target.value);
        if (e.key === "Enter") {
          const searched = e.target.value;
          fetchBankDetails(
            1,
            sizePerPage,
            searched,
            sortName,
            sortOrder,
            "",
            "",
            selectPeriod
            
          );
        }
        if (e.type === "keyup") {
          if (e.target.value === "") {
            fetchBankDetails(
              1,
              sizePerPage,
              "",
              sortName,
              sortOrder,
              "",
              "",
              selectPeriod
            );
          }
        }
      };

      const exportToExcel = () => {
        const fileName = "BRS_Report.xlsx";
        const headerMap = {
          accountCategory: "CATEGORY",
          accountName: "ACCOUNT NAME",
          contactName: "CONTACT NAME",
          transactionDate: "TRANSACTION DATE",
          transactionType: "TRANSACTION TYPE",
          transactionDetails: "TRANSACTION DETAILS",
          referenceNumber: "REFERENCE NUMBER",
          voucherNo: "VOUCHER NO",
          debits: "DEBITS",
          credits: "CREDITS",
        };
      
        const fieldsToExport = Object.keys(headerMap); 
        const filteredData = data.map((item) => {
          const filteredItem = {};
          fieldsToExport.forEach((field) => {
            if (field === "transactionDate" && item[field]) {
              const dateObj = new Date(item[field]);
              filteredItem[headerMap[field]] = dateObj.toISOString().split("T")[0];
            } else {
              filteredItem[headerMap[field]] = item[field];
            }
          });
          return filteredItem;
        });
      
        const ws = XLSX.utils.json_to_sheet(filteredData);
        const headers = Object.values(headerMap);
        XLSX.utils.sheet_add_aoa(ws, [headers], { origin: "A1" });
        ws['!cols'] = headers.map(() => ({ wch: 20 }));
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "BRS Data");
        XLSX.writeFile(wb, fileName);
      };
      
      

      // useEffect(() => {
      //   fetchBankDetails(
      //     page,
      //     sizePerPage,
      //     searchVal,
      //     "",
      //     "",
      //     "" ,
      //     "",
      //     selectPeriod    
      //   );
      // }, [])

      useEffect(() => {
        if (selectPeriod !== "Custom") {
            fetchBankDetails(
                page,
                sizePerPage,
                searchVal,
                "",
                "",
                "",
                "",
                selectPeriod
            );
        }
    }, [selectPeriod]);
    
    
 

  
  return (
    <div>
    <div className="row">
      <div className="col-md-12">
        <div className="card card-borderless cc-greyCard-custm mb-3">
          <div className="ms-2 my-2 me-2 ">
            <div className="d-flex justify-content-between flex-wrap align-items-center">
              <h4 className="m-0">Banking Summary</h4>
              <div className="d-flex justify-content-end text-t-primary kk-table-header kk-header-sec  cc-font-size-14">
                <div className="col">
                  {/* <Dropdown
                    className="col-auto text-start me-3"
                    value={filterSelected}
                    options={itemStatus}
                    // onChange={(e) => accountChange(e)}
                    scrollHeight="400px"
                    placeholder="Select account"
                  /> */}
                      

                  <Space.Compact className="my-auto mx-2">
                    <Input
                      addonBefore={<SearchOutlined />}
                      allowClear
                      placeholder="Search"
                      value={searchVal}
                      onChange={(e) => keySearch(e)}
                      onKeyUp={(e) => keySearch(e)}
                    />
                  </Space.Compact>

                  <Primedropdown
                          value={selectPeriod}
                          onChange={(e) => {
                            setSelectPeriod(e.value);
                          }}
                          options={items}
                          optionLabel="label"
                          placeholder="Select status to filter"
                          className="col-auto text-start me-3 my-auto"
                        />
                        
                         {selectPeriod === "Custom" && <Space
                            direction="vertical"
                            className="col-auto mx-3"
                            size={12}
                          >
                            <RangePicker
                              onChange={handleDateRange}
                              picker="date"
                            />
                          </Space>}
                          <button
                    className="btn btn-primary py-1 me-2 kk-btnThin my-2"
                    style={{
                                  // backgroundColor: "#dddddd",
                                  border: "none",
                                  color: "black !important",
                                }}
                    onClick={exportToExcel}
                  >
                    {" "}
                     Export
                  </button>

                          <button className="btn btn-danger" onClick={parentData.goback}>
                        Back
                      </button>
                        
                        
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* {balances && balances.length !== 0 && (
          <div className="cc-greyCard-custm card-borderless mb-3 p-2">
            <div className="row">
              {balances.map((x, i) => (
                <div key={i} className="col-md-3 p-2">
                  <div className="d-flex ps-2">
                    <p className="ms-3">
                      {x.label}
                      <br />
                      <b>{currency+ ' ' +x?.amount.toFixed(2)}</b>
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )} */}
        <div className="bg-white shadow-sm chart-of-account h-100 cc-greyCard-custm1">
          <div className="row coa-header kk-header-sec">
            <div className="col-auto header-right ms-auto"></div>
          </div>
          <div className="account-table ">
            <DataTable
              stripedRows
              className=""
              value={data}
              // header={header}
              // responsiveLayout="scroll"
              size="small"
              loading={tdataLoad}
              paginator
              lazy
              totalRecords={totalRecordsIn}
              paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
              rowsPerPageOptions={[10, 20, 50, totalRecordsIn]}
              first={first1}
              rows={sizePerPage}
              onPage={onCustomPage1}
              onSort={onSort}
              sortField={lazyParams.sortField}
              sortOrder={lazyParams.sortOrder}
            >
              <Column field="transactionDate" header="Transcation Date" body={(row) => (
                <div>
                  {" "}
                  {format(
                    new Date(row.transactionDate),
                    GV.userDet.tenantConfig.dateFormat
                  )}
                </div>
              )}/>
              <Column field="transactionType" header="Transaction Type" />
              <Column field="transactionDetails" header="Transaction Details " />

              <Column field="voucherNo" header="Voucher No" />
              <Column field="contactName" header="Contact Name" />
              <Column field="accountName" header="Account Name" />
              {/* <Column field="accountType" header="Account Type" /> */}
              <Column field="accountCategory" header="Account Category" />

              {/* <Column field="entryDate" header="Entry Date" body={(row) => (
                <div>
                  {" "}
                  {format(
                    new Date(row.entryDate),
                    GV.userDet.tenantConfig.dateFormat
                  )}
                </div>
              )}/> */}
             
              
              <Column field="debits" className="text-end amount-align" body={(a) => GlobalVariable.userDet.tenantConfig.currency + " " +a.debits.toFixed(2)} header="Debits" />
              <Column field="credits" className="text-end amount-align" body = {(a) => GlobalVariable.userDet.tenantConfig.currency + " " +a.credits.toFixed(2)} header="Credits" />
            </DataTable>
          </div>
        </div>
      </div>
    </div>
    
  </div>
  )
}

export default BankTransaction